// Which visitor page a scanned QR code opens. QR codes encode
// `<FRONTEND_URL>/<exhibit|zone|exhibition>/<id>`; anything from another host
// or any other path is rejected. F-AA: exhibition codes were rejected before
// (path not listed, and `exb_…` ids contain an underscore).
const PATH_RE = /^\/(exhibit|zone|exhibition)\/([A-Za-z0-9_-]+)\/?$/;

export function parseScannedPath(value, hostname) {
  if (!value) return null;
  let url;
  try {
    url = new URL(String(value).trim());
  } catch {
    return null;
  }
  if (url.hostname !== hostname) return null;
  const match = url.pathname.match(PATH_RE);
  return match ? `/${match[1]}/${match[2]}` : null;
}
